import React from "react";
import "./TechnologyStack.scss";

// Example custom icons (replace these with your own)
import htmlIcon from "../../assets/images/icons/xcode.svg";
import androidIcon from "../../assets/images/icons/android.svg";
import appleIcon from "../../assets/images/icons/apple.svg";
import firebaseIcon from "../../assets/images/icons/firebase.svg";
import kotlinIcon from "../../assets/images/icons/kotlin.svg";
import mysqlIcon from "../../assets/images/icons/mysql.svg";
import swiftIcon from "../../assets/images/icons/swift.svg";

const techs = [
    { name: "HTML5", icon: htmlIcon },
    { name: "Android", icon: androidIcon },
    { name: "Apple", icon: appleIcon },
    { name: "Firebase", icon: firebaseIcon },
    { name: "Kotlin", icon: kotlinIcon },
    { name: "MySQL", icon: mysqlIcon },
    { name: "Swift", icon: swiftIcon },
];

const TechnologyStack = () => {
    return (
        <section className="tech-stack" id="tech-stack">
            <h2>Technology Stack</h2>
            <div className="tech-stack__wrapper">
                <div className="tech-stack__icons">
                    {techs.map((tech, i) => (
                        <div className="tech-icon" key={i}>
                            <div className="icon-box">
                                <img src={tech.icon} alt={tech.name} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TechnologyStack;
